import { Component } from "react";
import withAuth from "../withAuth";
import { compose } from "redux";
import { connect } from "react-redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import IconButton from "@mui/material/IconButton";
import {
    setRisks,
    getDefaultRisk,
    getMaxRiskId,
    setRiskType,
    setNbCompaniesDisplay
} from "../../redux/analyseRisques/analyseRisquesActions";
import { arIsReadonly } from "../../redux/analyseRisques/analyseRisquesStatusActions";
import MenuItem from "@mui/material/MenuItem";
import SolutionsTable from "./SolutionsTable";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import PhotoIcon from "@mui/icons-material/PhotoCamera";
import PreviewIcon from "@mui/icons-material/Photo";
import WarningIcon from '@mui/icons-material/Warning';
import InputPhoto from "../Photos/InputPhoto";
import PreviewImage from "../Photos/PreviewImage";
import "./AnalyseRisques.css";
import { clone } from "../../utils";
import { uploadImage } from "../../redux/image/imageActions";
import { FormControl, InputLabel } from "@mui/material";
import CustomizedSelect from "../Input/CustomizedSelect";

class RisqueCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            importImage: false,
        };
    }

    riskTypeChange(e) {
        let details = clone(this.props.currentRisks);

        if (!details[this.props.currentRiskRowIndex]) return;

        this.props.setRiskType(
            details[this.props.currentRiskRowIndex],
            e.target.value,
            this.props.riskTypes,
            this.props.header,
            this.props.currentRisks,
            this.props.ppeList,
            this.props.activeUser,
            this.props.participants,
            this.props.nbCompaniesDisplay
        );
    }

    takePhoto() {
        this.inputImage.click();
    }

    closePhotoImportation(image) {
        this.setState({
            previewPhoto: image ? true : false,
        });

        let risks = clone(this.props.currentRisks);

        if (!risks[this.props.currentRiskRowIndex]) return;

        risks[this.props.currentRiskRowIndex].image = image
            ? image
            : this.props.image;

        this.props.setRisks(risks);
    }

    previewPhoto() {
        this.setState({
            previewPhoto: true,
        });
    }

    closePhotoPreview() {
        this.setState({
            previewPhoto: false,
        });
    }

    deleteRisk() {
        const risks = clone(this.props.currentRisks);

        let indexOfDetailToDelete = this.props.currentRiskRowIndex;

        if (indexOfDetailToDelete !== undefined && indexOfDetailToDelete >= 0) {
            risks.splice(indexOfDetailToDelete, 1);

            this.props.setRisks(
                risks,
                this.props.riskTypes,
                this.props.header,
                this.props.currentRisks,
                this.props.ppeList
            );
        }
    }

    addRisk() {
        const currentRisks = this.props.currentRisks;
        currentRisks.push(
            getDefaultRisk(
                getMaxRiskId(this.props.currentRisks),
                0,
                this.props.instructionTypes,
                this.props.activeUser
            )
        );
        this.props.setRisks(currentRisks);
    }

    deletePhoto() {
        this.setState({
            importImage: false,
            previewPhoto: false,
        });

        let risks = this.props.currentRisks;

        if (!risks[this.props.currentRiskRowIndex]) return;

        risks[this.props.currentRiskRowIndex].image = null;

        this.props.setRisks(risks);
    }

    importImage(image) {
        this.props.uploadImage(image);
        this.closePhotoImportation(image);
    }

    handleRef = (r) => {
        this.inputImage = r;
    };

    render() {
        let currentRiskRowIndex = this.props.currentRiskRowIndex + 1;

        let photoIconElement;

        if (!this.props.currentRisk.image) {
            photoIconElement = (
                <IconButton onClick={this.takePhoto.bind(this)}>
                    <PhotoIcon />
                </IconButton>
            );
        } else if (this.props.currentRisk.image) {
            photoIconElement = (
                <IconButton onClick={this.previewPhoto.bind(this)}>
                    <PreviewIcon className="green-button" />
                </IconButton>
            );
        }

        if (this.props.currentRisk.id === 0) {
            return (
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 risk-card-container">
                    <Card
                        className={
                            "card without-padding add-risk-card " +
                            (arIsReadonly(this.props.header) ? "disabled" : "")
                        }
                    >
                        <CardContent
                            className={
                                this.props.readonly
                                    ? "disabled without-padding"
                                    : "without-padding"
                            }
                        >
                            <IconButton
                                className="risk-card-icon-container"
                                onClick={this.addRisk.bind(this)}
                            >
                                <AddIcon className="risk-card-full-size-icon" />
                            </IconButton>
                        </CardContent>
                    </Card>
                </div>
            );
        }

        return (
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 risk-card-container">
                <InputPhoto
                    handleRef={this.handleRef.bind(this)}
                    importImage={this.importImage.bind(this)}
                />
                {this.state.previewPhoto ? (
                    <PreviewImage
                        close={this.closePhotoPreview.bind(this)}
                        delete={this.deletePhoto.bind(this)}
                        image={this.props.currentRisk.image}
                    />
                ) : null}
                <Card
                    className={
                        "card without-padding " +
                        (arIsReadonly(this.props.header) ? "disabled" : "")
                    }
                >
                    <CardHeader
                        style={{ color: "rgb(117, 117, 117)" }}
                        title={"Risque " + currentRiskRowIndex}
                        action={
                            <div>
                                {photoIconElement}
                                <IconButton
                                    onClick={this.deleteRisk.bind(this)}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        }
                    />
                    <CardContent
                        className={
                            this.props.readonly
                                ? "disabled without-padding"
                                : "without-padding"
                        }
                    >
                        <div className="center col-lg-12 col-md-12 col-sm-12 col-12 row margin-bottom">
                            <FormControl className="row">
                                <InputLabel id="risk-type-label">
                                    Type de risque
                                </InputLabel>
                                <CustomizedSelect
                                    labelId="risk-type-label"
                                    id="risk-type"
                                    label="Type de risque"
                                    inputProps={{
                                        name: "riskType",
                                        id: "riskType",
                                    }}
                                    className="full_size"
                                    required
                                    onChange={this.riskTypeChange.bind(this)}
                                    value={
                                        this.props.currentRisk.riskTypeId
                                            ? this.props.currentRisk.riskTypeId
                                            : ""
                                    }
                                >
                                    {this.props.riskTypes
                                        .filter((rt) => !rt.parent_id)
                                        .map((rt) => {
                                            return (
                                                <MenuItem
                                                    key={rt.id}
                                                    value={rt.id}
                                                >
                                                    {rt.is_major ? <WarningIcon sx={{marginRight: "5px", fontSize: "larger", color: "red"}}/> : null} 
                                                    {rt.name}
                                                </MenuItem>
                                            );
                                        })}
                                </CustomizedSelect>
                            </FormControl>
                        </div>
                        <div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding">
                            <SolutionsTable
                                solutions={this.props.currentRisk.solutions}
                                currentRisk={this.props.currentRisk}
                            />
                        </div>
                    </CardContent>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        header: state.analyseRisques.header,
        currentRisks: state.analyseRisques.risks,
        riskTypes: state.riskTypes.types,
        image: state.image.image,
        instructionTypes: state.solutionTypes.types,
        ppeList: state.ppeList.ppeList,
        activeUser: state.activeUser,
        participants: state.analyseRisques.participants,
        nbCompaniesDisplay: state.analyseRisques.nbCompaniesDisplay
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRisks: (risks, riskTypes, header, oldRisks, allPpe) =>
            dispatch(setRisks(risks, riskTypes, header, oldRisks, allPpe)),
        setRiskType: (
            risk,
            newRiskTypeId,
            riskTypes,
            header,
            oldRisks,
            allPpe,
            connectedUser,
            participants,
            nbCompaniesDisplay
        ) =>
            dispatch(
                setRiskType(
                    risk,
                    newRiskTypeId,
                    riskTypes,
                    header,
                    oldRisks,
                    allPpe,
                    connectedUser,
                    participants,
                    nbCompaniesDisplay
                )
            ),
        uploadImage: (image) => dispatch(uploadImage(image)),
        setNbCompaniesDisplay: (nbCompaniesDisplay) => dispatch(setNbCompaniesDisplay(nbCompaniesDisplay))
    };
};

export default compose(
    withAuth,
    connect(mapStateToProps, mapDispatchToProps)
)(RisqueCard);
